import { useQuery } from '@tanstack/react-query'
import { api } from '@jupi/ui'

// The aerodrome lookup list (/api/aerodromes), for the flight log's airfield
// fields. A few hundred rows that change a few times a year: fetched once
// and kept for the session (the server also sends a cache header), so the
// field filters it in the browser as the member types.

export interface Aerodrome {
  code: string
  name: string | null
}

export function useAerodromes() {
  return useQuery({
    queryKey: ['aerodromes'],
    queryFn: () => api.get<{ aerodromes: Aerodrome[] }>('/api/aerodromes').then((r) => r.aerodromes),
    staleTime: Infinity,
    gcTime: Infinity,
  })
}
